import AsyncStorage from '@react-native-async-storage/async-storage';
import { WritableAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { Platform } from 'react-native';

const _atomStorage = <T>(key: string, initialValue: T) => {
  let storage;
  if (Platform.OS === 'web') {
    storage = createJSONStorage(() => localStorage);
  } else {
    storage = { ...createJSONStorage(() => AsyncStorage), delayInit: true };
  }

  return atomWithStorage(key, initialValue, storage);
};

// another const just to have the typing
export const atomStorage = _atomStorage as <T>(
  key: string,
  initialValue: T,
) => WritableAtom<T, T, void>;
